import { Divider, Flex } from 'antd';
import classNames from 'classnames';
import styles from './InfoCard.module.css';

interface InfoCardProps {
  className?: string;
  title: React.ReactNode;
  items: { label: string; value: string }[];
}

const InfoCard: React.FC<InfoCardProps> = ({ className, title, items }) => {
  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.header}>{title}</div>
      <Divider className={styles.divider} />
      <Flex vertical gap={4}>
        {items?.map((item) => (
          <div className={styles.item} key={item.label}>
            <span>{item.label}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </Flex>
    </div>
  );
};

export default InfoCard;
